'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { loggerLink, unstable_httpBatchStreamLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { useState } from 'react';

import { type AppRouter } from '../root';
import { getUrl, transformer } from './shared';
import { SessionProvider, Session } from '@repo/auth';

const api = createTRPCReact<AppRouter>();

export function TRPCAuthSessionReactProvider({
  children,
  session
}: {
  children: React.ReactNode;
  session: Session;
}): React.JSX.Element {
  const [queryClient] = useState(() => new QueryClient());

  const [trpcClient] = useState(() =>
    api.createClient({
      transformer,
      links: [
        loggerLink({
          enabled: (op) =>
            process.env.NODE_ENV === 'development' ||
            (op.direction === 'down' && op.result instanceof Error)
        }),
        unstable_httpBatchStreamLink({
          // TODO: fix getUrl
          url: getUrl()
        })
      ]
    })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <api.Provider client={trpcClient} queryClient={queryClient}>
        <SessionProvider session={session}>{children}</SessionProvider>
      </api.Provider>
    </QueryClientProvider>
  );
}
